import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getUSerSalery( userId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETSALARY + userId, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getUserSaleryDetails(userId: string, userDocId: string ) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(urls.GETSALARY + userId + "/" + userDocId, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }
